export default __webpack_public_path__ + "static/media/success_icon.2d6555ae.svg";